// extracted by mini-css-extract-plugin
export default {"videoWithAdDetail":"VideoWithAdDetail_videoWithAdDetail__W9hDX","videoWithAdDetailPreviewSwitch":"VideoWithAdDetail_videoWithAdDetailPreviewSwitch__bV-Zi"};